import colors from "@/constants/colors"

export const titleWrapper = {
  borderTopLeftRadius: 16,
  borderTopRightRadius: 16,
  fontSize: { xs: 20, md: 24 },
  fontWeight: 400,
  px: { xs: 3, md: 4 },
  py: 2,
  backgroundColor: "selectInputBackground",
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
}

export const title = {
  fontSize: { xs: 20, md: 24 },
  color: colors.staking.dark,
}

export const contentWrapper = {
  fontWeight: 400,
}

export const buttonSubmit = {
  width: "100%",
  lineHeight: "2rem",
  fontSize: 20,
  fontWeight: 700,
}

// Stats
export const estimateWrapper = {
  textAlign: "right",
}

export const estimateAmount = {
  fontWeight: 700,
  color: colors.staking.dark,
}

export const estimateText = {
  color: colors.staking.gray2,
}

export const helperText = {
  mb: 3,
  textAlign: "center",
}

export const link = {
  textDecoration: "none",
  color: "white",
  underline: "none",
}

export const stakingAPYText = {
  fontWeight: 600,
  color: colors.staking.darkGreen,
}
